import { useRef } from 'react'
import { Dialog } from '../DialogV2'
import { Button } from '../button'
import { Text } from '../typography/text'

export interface MoteSaveToMotebookDialogProps {
  onClose: () => void
  onConfirm: () => void
  loading?: boolean
}

export function MoteDeleteConfirmationDialog(
  props: MoteSaveToMotebookDialogProps
) {
  const cancelButtonRef = useRef<HTMLButtonElement>(null)

  return (
    <Dialog
      isOpen
      maxWidth={420}
      onClose={props.onClose}
      id={'delete-confirmation-dialog'}
      initialFocusRef={cancelButtonRef}
      rootProps={{ role: 'alertdialog' }}
    >
      <Dialog.Header>Delete mote</Dialog.Header>
      <Dialog.Content>
        <Text color={'grey.d2'}>Are you sure? You can’t undo this action.</Text>
      </Dialog.Content>
      <Dialog.Footer>
        <Button
          //@ts-expect-error
          variant='secondary'
          onClick={props.onClose}
          text='Cancel'
          ref={cancelButtonRef}
        />
        <Button
          //@ts-expect-error
          variant={'warning'}
          text='Yes, delete'
          loadingText='Saving ...'
          onClick={props.onConfirm}
          loading={props.loading}
        />
      </Dialog.Footer>
    </Dialog>
  )
}
